import React from 'react';
import { useTable } from 'react-table';
import './GenericTable.css';


const GenericTable = ({ columns, data, onRowClick }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({ columns, data });

  return (
    <table {...getTableProps()} className="generic-table">
      <thead>
        {headerGroups.map((headerGroup, i) => (
          <tr {...headerGroup.getHeaderGroupProps()} key={i}>
            {headerGroup.headers.map((column, j) => (
              <th {...column.getHeaderProps()} key={j}>
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="no-data">
              Nu există date disponibile
            </td>
          </tr>
        ) : (
          rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i} className = {onRowClick && "clickable-row"}>
              {row.cells.map((cell, j) => {
                const isClickable = cell.column.enableCellClick ?? true;
                return (
                <td
                  {...cell.getCellProps()}
                  key={j}
                  onClick={() => {
                    if (isClickable) onRowClick?.(row);
                  }}
                  className={!isClickable ? 'clickable-cell' : ''}
                >
                  {cell.render('Cell')}
                </td>
              )})}
            </tr>
            );
          })
        )}
    </tbody>
    </table>
  );
};

export default GenericTable;
